/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)


/* CLOSE ICON */
export const CloseIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* CHECK ICON */
export const CheckIcon = ({ size = 12 }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6 9 17l-5-5" />
    </svg>
)

/* PLUS ICON */
export const PlusIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M12 5v14M5 12h14" />
    </Icon>
)

/* EDIT ICON */
export const EditIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M11 4H7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-4" />
        <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
    </Icon>
)

/* TRASH ICON */
export const TrashIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" />
        <path d="M10 11v5M14 11v5" />
    </Icon>
)

/* LOCK ICON */
export const LockIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="4" y="11" width="16" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </Icon>
)

/* INFO ICON */
export const InfoIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 8h.01" />
    </Icon>
)

/* STUDIO ICON — A CAMERA ON A STAND */
export const StudioIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <rect x="2" y="6" width="13" height="9" rx="2" />
        <path d="m15 10.5 5-3v9l-5-3M7 15v5M4 20h6" />
    </Icon>
)

/* BROADCAST ICON — THE WAVES OF A LIVE STREAM */
export const BroadcastIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="2.5" />
        <path d="M8 8a5.5 5.5 0 0 0 0 8M16 8a5.5 5.5 0 0 1 0 8" />
        <path d="M5 5a10 10 0 0 0 0 14M19 5a10 10 0 0 1 0 14" />
    </Icon>
)

/* TABLE ICON */
export const TableIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <ellipse cx="12" cy="10" rx="9" ry="5" />
        <path d="M12 15v6M8 21h8" />
    </Icon>
)

/* DEALER ICON */
export const DealerIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="8" r="3.5" />
        <path d="M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6" />
    </Icon>
)

/* USERS ICON */
export const UsersIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="9" cy="8" r="3.5" />
        <path d="M2.5 20c0-3.4 2.9-5.7 6.5-5.7s6.5 2.3 6.5 5.7" />
        <path d="M17 5.2a3.5 3.5 0 0 1 0 6.6M18.5 14.8c1.9.8 3 2.5 3 4.7" />
    </Icon>
)

/* KEY ICON — THE TOKEN OF A STUDIO */
export const KeyIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="8" cy="15" r="4" />
        <path d="m10.8 12.2 8-8M17 3l4 4M14.5 6.5l3 3" />
    </Icon>
)

/* LINK ICON — AN ADDRESS OF A STUDIO */
export const LinkIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M10 13.5a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1.7 1.7" />
        <path d="M14 10.5a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1.7-1.7" />
    </Icon>
)

/* SERVER ICON */
export const ServerIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3" y="4" width="18" height="7" rx="2" />
        <rect x="3" y="13" width="18" height="7" rx="2" />
        <path d="M7 7.5h.01M7 16.5h.01" />
    </Icon>
)

/* VIDEO ICON */
export const VideoIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="2.5" y="6" width="13" height="12" rx="2" />
        <path d="m15.5 12 6-3.5v11l-6-3.5" />
    </Icon>
)

/* AUDIO ICON */
export const AudioIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="9" y="2.5" width="6" height="11" rx="3" />
        <path d="M5 11a7 7 0 0 0 14 0M12 18v3.5M8.5 21.5h7" />
    </Icon>
)

/* UPLOAD ICON */
export const UploadIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <path d="M12 20V4M6 10l6-6 6 6" />
    </Icon>
)

/* DOWNLOAD ICON */
export const DownloadIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <path d="M12 4v16M6 14l6 6 6-6" />
    </Icon>
)

/* SPEED ICON */
export const SpeedIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <path d="M3.5 18a9 9 0 1 1 17 0" />
        <path d="m15 10-3.5 4.5" />
        <circle cx="12" cy="18" r="1.5" />
    </Icon>
)

/* CPU ICON */
export const CpuIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="6" y="6" width="12" height="12" rx="2" />
        <rect x="10" y="10" width="4" height="4" rx="1" />
        <path d="M9 3v3M15 3v3M9 18v3M15 18v3M3 9h3M3 15h3M18 9h3M18 15h3" />
    </Icon>
)

/* ARCHIVE ICON */
export const ArchiveIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="3" y="4" width="18" height="5" rx="1.5" />
        <path d="M5 9v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9M10 13h4" />
    </Icon>
)

/* REFRESH ICON */
export const RefreshIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <path d="M20 11a8 8 0 0 0-13.7-5.3L4 8" />
        <path d="M4 4v4h4" />
        <path d="M4 13a8 8 0 0 0 13.7 5.3L20 16" />
        <path d="M20 20v-4h-4" />
    </Icon>
)

/* EYE ICON */
export const EyeIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12Z" />
        <circle cx="12" cy="12" r="2.6" />
    </Icon>
)

/* KICK ICON — A PARTICIPANT LEAVES THE ROOM */
export const KickIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M14 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3" />
        <path d="M9 8 5 12l4 4M5 12h9" />
    </Icon>
)

/* ARROW ICON — THE ROOM IS OPENED */
export const ArrowIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <path d="M5 12h13M13 6l6 6-6 6" />
    </Icon>
)

/* COPY ICON */
export const CopyIcon = ({ size = 12 }) => (
    <Icon size={size}>
        <rect x="9" y="9" width="12" height="12" rx="2" />
        <path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1" />
    </Icon>
)
